<template>
  <div class="not-found-container">
    <h1>404 - {{ $t('pagina_no_encontrada') }}</h1>
    <p>{{ $t('mensaje_no_encontrada') }}</p>
    <button @click="goToHome" class="btn-home">{{ $t('volver_inicio') }}</button>
  </div>
</template>

<script>
export default {
  methods: {
    goToHome() {
      this.$router.push({ name: 'Welcome' });
    },
  },
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  background-color: #f5f5f5;
}

.not-found-container h1 {
  font-size: 36px;
  color: #99172A;
  margin-bottom: 20px;
}

.not-found-container p {
  font-size: 18px;
  color: #333;
  margin-bottom: 30px;
}

.btn-home {
  background-color: #99172A;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-home:hover {
  background-color: #7A1222;
}
</style>